import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

const myCircleInfo: IconDefinition = {
    icon: [
        512,
        512,
        ["info-circle"],
        "f05a",
        "M256 512C397.4 512 512 397.4 512 256C512 114.6 397.4 0 256 0C114.6 0 0 114.6 0 256C0 397.4 114.6 512 256 512z M256 462C142.23 462 50 369.77 50 256C50 142.23 142.23 50 256 50C369.77 50 462 142.23 462 256C462 369.77 369.77 462 256 462z M224 160C224 142.3 238.3 128 256 128C273.7 128 288 142.3 288 160C288 177.7 273.7 192 256 192C238.3 192 224 177.7 224 160z M216 224L264 224C277.3 224 288 234.7 288 248L288 336L296 336C309.3 336 320 346.7 320 360C320 373.3 309.3 384 296 384L216 384C202.7 384 192 373.3 192 360C192 346.7 202.7 336 216 336L240 336L240 272L216 272C202.7 272 192 261.3 192 248C192 234.7 202.7 224 216 224z"
    ],
    iconName: "circle-info",
    prefix: "fas"
}

export default myCircleInfo;